// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"25232b01","208":"45e6de60","236":"75f14d81","353":"bea66c24","512":"abf6f86d","549":"6afe31cb","813":"fe13573a"}[chunkId] + ".chunk.js";
};